"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterBar = void 0;
var _footerModule = _interopRequireDefault(require("@albelli/arc-3/lib/footer.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = require("../Grid");
var _LanguageSelector = require("../LanguageSelector/LanguageSelector");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const vendorFlags = [{
  vendorId: "albelli.nl",
  flag: "flag-nl",
  text: "NL"
}, {
  vendorId: "albelli.be",
  flag: "flag-be",
  text: "BE"
}, {
  vendorId: "posterxxl.de",
  flag: "flag-de",
  text: "DE"
}, {
  vendorId: "posterxxl.at",
  flag: "flag-at",
  text: "AT"
}, {
  vendorId: "photobox.fr",
  flag: "flag-fr",
  text: "FR"
}, {
  vendorId: "photobox.co.uk",
  flag: "flag-uk",
  text: "UK"
}, {
  vendorId: "photobox.ie",
  flag: "flag-ie",
  text: "IE"
}, {
  vendorId: "photobox.it",
  flag: "flag-it",
  text: "IT"
}, {
  vendorId: "photobox.dk",
  flag: "flag-dk",
  text: "DK"
}, {
  vendorId: "fotoknudsen.no",
  flag: "flag-no",
  text: "NO"
}, {
  vendorId: "onskefoto.se",
  flag: "flag-se",
  text: "SE"
}, {
  vendorId: "hofmann.es",
  flag: "flag-es",
  text: "ES"
}, {
  vendorId: "hofmann.pt",
  flag: "flag-pt",
  text: "PT"
}];
const FooterBar = _ref => {
  let {
    links,
    copyright,
    vendor,
    vendorLinks
  } = _ref;
  const vendorFlagLinks = (0, _react.useMemo)(() => {
    const vendorLinksMap = vendorLinks || {};
    return vendorFlags.map(f => ({
      href: vendorLinksMap[f.vendorId] || window.location.href.replace(vendor, f.vendorId),
      ...f
    }));
  }, [vendor, vendorLinks]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: _footerModule.default["arc3-footer__end-row"]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("arc3-container", _footerModule.default["arc3-container"])
  }, /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
    container: true,
    className: _footerModule.default["arc3-grid"]
  }, /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
    cell: true,
    className: _footerModule.default["arc3-cell"],
    column: 4,
    columnTablet: 3,
    columnPhone: 2
  }, /*#__PURE__*/_react.default.createElement("p", null, copyright)), /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
    cell: true,
    className: _footerModule.default["arc3-cell"],
    column: 8,
    columnTablet: 9,
    columnPhone: 12
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "arc3-typo-ul-no-style ".concat(_footerModule.default["arc3-footer__anchor"], " ").concat(_footerModule.default["arc3-footer__horizontal-menu"])
  }, !!links && links.map((i, j) => /*#__PURE__*/_react.default.createElement("li", {
    key: j
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: i.href
  }, i.text))), /*#__PURE__*/_react.default.createElement(_LanguageSelector.LanguageSelector, {
    vendorFlagLinks: vendorFlagLinks,
    currentVendor: vendor
  }))))));
};
exports.FooterBar = FooterBar;